export { default as DocIcon } from '@assets/icons/doc-icon.svg';
export { default as XlsIcon } from '@assets/icons/xls-icon.svg';
export { default as PdfIcon } from '@assets/icons/pdf-icon.svg';
export { default as ZipIcon } from '@assets/icons/zip-icon.svg';
export { default as PPtIcon } from '@assets/icons/ppt-icon.svg';
